import { BodyGrey } from '../Typography';
import { Box, Breadcrumbs as MUIBreadcrumbs, Link } from '@mui/material';
import { ContentContainer as LayoutContentContainer, RootContainer } from '../layout/Containers';
import { fontWeight } from '../../theme/typography';
import { HFlex, VFlex } from '../FlexContainers';
import { palette } from '../../theme/palette';
import { styled } from '@mui/system';

export const Root = styled(RootContainer)`
  padding-top: 42px;
  padding-bottom: 88px;
`;

export const Container = styled(LayoutContentContainer)``;

export const Breadcrumbs = styled(MUIBreadcrumbs)`
  li {
    padding-right: 0px;
  }
`;

export const BreadcrumbLink = styled(Link)`
  letter-spacing: 0.675px;
  color: ${palette.custom.darkGrey};
  width: fit-content;
  font-size: 13.5px;
  font-style: normal;
  font-weight: ${fontWeight.bold};
  line-height: normal;
  letter-spacing: 0.675px;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  :hover {
    text-decoration: underline;
  }
  @media (max-width: 767px) {
    :hover {
      text-decoration: none;
    }
  }
`;

export const BreadcrumbText = styled(BodyGrey)`
  letter-spacing: 0.675px;
  font-size: 13.5px;
  font-weight: ${fontWeight.bold};
  text-transform: uppercase;
  margin-bottom: 0px;
`;

export const PageTitle = styled(Box)`
  color: ${palette.custom.darkGrey};
  font-size: 38px;
  font-style: normal;
  font-weight: 800;
  line-height: 38px;
  letter-spacing: 0.95px;
  text-transform: capitalize;
  margin-top: 4px;
`;

export const PageHeaderWrapper = styled(VFlex)``;

export const TableTabs = styled(HFlex)`
  gap: 40px;
`;

export const HeaderWrapper = styled(HFlex, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{
  active?: boolean;
}>`
  margin: 53.5px 6px 5px 6px;
  width: 57px;
  height: 29px;
  position: relative;
  cursor: pointer;
  font-size: 13.5px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.675px;
  color: ${(props) => (props.active ? palette.custom.darkGrey : '#9E9EA6')};

  &::after {
    content: '';
    height: 8px;
    background: ${(props) => (props.active ? palette.primary.main : 'unset')};
    top: 32px;
    position: absolute;
    z-index: 1;
    right: -9%;
    border-radius: 45px;
    width: 69px;
    border: 5px;
  }
`;

export const LineBreak = styled(Box)`
  height: 1px;
  width: 100%;
  background-color: ${palette.custom.extraLightGrey};
`;

export const NoOrderMessage = styled(Box)``;
